import type { CopilotThemeOptions } from 'owa-copilot-themes-types';
import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';

/**
 * Updates the copilot theme option data in the copilot theme store
 * @param status the copilot theme option data
 */
const updateCopilotThemeOptionsMutator: (
    copilotThemeData: CopilotThemeOptions,
    timestamp: string
) => void = mutatorAction(
    'updateCopilotThemeOptions',
    (copilotThemeData: CopilotThemeOptions, timestamp: string): void => {
        getStore().options = copilotThemeData;
        getStore().timestamp = timestamp;
    }
);
export default updateCopilotThemeOptionsMutator;
